module.exports = require("zlib");;